import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  AfterContentInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  OnInit
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';
import { ConfirmationService, SelectItem } from 'primeng-lts/api';

import {
  AwardDTO,
  ProcurementProjectDTO,
  ProcurementProjectLotDTO,
  AwardLotDTO,
  ValidationResultDTO,
  ResultTypeDTO,
  ActionParameterDefinitionDTO,
  ProjectRelationDTO,
  CofinancingLineDTO,
  BudgetAccountLineDTO
} from '../../api/plyca-dtos-v2';
import { FormConfig } from '../../components/forms/form.objects';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import {
  getSimpleIdentifierFromString,
  TenderDTO,
  WorkProcurementProjectAwardsDTO,
  TenderLot,
  TaskDTO,
  TenderLotV2DTO,
  SearchSelectionResultDTO
} from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';

import { formPlycaComponent } from '../../components/forms/formPlyca.component';

import * as lodash from 'lodash';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';

import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';

import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { flatMap, finalize, tap, catchError } from 'rxjs/operators';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AwardRequestedMaterialListComponent } from '../requestedMaterial/AwardRequestedMaterialList.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { UnitPricesListComponent } from '../unitPrices/UnitPricesList.component';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { UserService } from '../../user.service';
import { ServiceLocator } from '../../ServiceLocator';
import { ProfileService } from '../../../services/profile.services';


@Component({
  selector: 'awardEdition',
  templateUrl: 'awardEdition.template.html'
})
export class awardEditionComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loaded = false;

  _awardId: string;
  award: AwardDTO;
  project: ProcurementProjectDTO;
  pendingLots: Array<ProcurementProjectLotDTO>;


  tendersList: Array<TenderDTO>;
  filteredTendersList: Array<TenderDTO>;
  tendersLots: Array<ProcurementProjectLotDTO> = [];
  taskWork: WorkProcurementProjectAwardsDTO;

  selectedLots: Array<ProcurementProjectLotDTO> = [];
  lotsModel: SelectItem[];

  tagsParent: string[];

  warning = false;
  error = false;

  relatedProject: boolean;

  params: string;
  resultActivarImporte: false;

  @ViewChild('frmAward') frmAward: formPlycaComponent;

  // referencia al formulario de edicion de datos
  formConfig: FormConfig;

  windowHash: string;
  public task: TaskDTO;

  private cliente: string;
  plycaErrorHandler: any;

  profileService: any;
  perfilesEdicionEmpresa: string;
  userCanEditCompany = false;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public dossierService: DossierService,
    public configuration: Configuration,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private confirmationService: ConfirmationService,
    private waitService: WaitLoadingService,
    private translateService: TranslateService,
    private appConfig: AppConfiguration,
    private userService: UserService
  ) {
    super();
    this.profileService = ServiceLocator.injector.get(ProfileService);

    this.cliente = this.appConfig.getValue('cliente');
    let context = dialogConfig['context'];
    if (context) {
      console.log('AWARDVIEW, CONTEXT:', context);
      this.tagsParent = context['tags'];
      this._awardId = context['awardId'];
      this.project = context['project'];

      this.pendingLots = context['pendingLots'];
      this.relatedProject = context['isRelatedProject'];
      this.tendersList = context['tendersList'];
      this.taskWork = context['taskWork'];


      if (this.project.breakdownLot.apportioned && this.pendingLots) {
        this.lotsModel = this.pendingLots.map(lot => {
          return { label: lot.description, value: lot };
        });
      }
    } else {
      console.log('No se ha recibido context al abrir awardView', dialogConfig);
    }
    this.task = dialogConfig?.data?.task;
  }

  ngOnInit(): void {
    this.initHeaderActions();

    this.perfilesEdicionEmpresa = this.profileService.patchProfilesByOPtion('MANTENIMIENTO', 'companyList');
    if (this.perfilesEdicionEmpresa) {
      this.userCanEditCompany = this.userService.hasRoles(this.perfilesEdicionEmpresa);
    }

    this.subscribe(this.loadAward(this._awardId)
      .pipe(

        tap((_award: AwardDTO) => {
          console.log('Recibida ', _award);
          this.award = _award;
          this.award.relatedProject = this.relatedProject;
          this.award.isEditableCompany = this.userCanEditCompany;
          this.award.isVisibleConcesion = this.project.euDirective !== undefined
            && this.project.euDirective.identifier === '2014/23/EU<>DIRECTIVA_UE' ? true : false

          if (this.taskWork !== undefined) {
            let context = this.award.context;
            this.award.context = lodash.mergeWith(context, this.taskWork.context);
            // this.award.context = this.taskWork.context;
          }
          this.updateAward(this.award, false);


          this.loaded = true;
          // this.waitService.cancelWaiting();
        }),
        flatMap(() => this.createFormConfig()),
        flatMap((form: FormConfig) => this.configureFormConfig(form)),
        tap((form: FormConfig) => (this.formConfig = form)),
        finalize(() => {
          // cargar datos cabecera
          // this.initHeaderInfo();

        }),
        catchError((error: any) => {
          console.log('manageFormException 2', error);

          this.frmAward.manageFormException(error);

          return throwError(error);
        })
      ));

    this.params = 'PROPUESTAID=' + this.project.identifier;
    //this.relatedData = {};

    forkJoin([
      this.plycaService.getAttributeValue(
        'FADJ_ACTIVAR_IMPORTES',
        this.params
      )
    ]).pipe(
      tap((result: any[]) => {
        if (result) {
          this.resultActivarImporte = result[0];
          if (this.resultActivarImporte) {

          }

        }
      }
      )
    );


  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {


    formConfig.showValidations = true;

    formConfig.isModalWindow = false;
    // formConfig.windowHash = this.windowHash;

    formConfig.functions.push({
      identifier: 'addNewLot',
      fn: this.addNewLot
    });
    formConfig.functions.push({
      identifier: 'sumAmountLot',
      fn: this.sumAmountLot
    });
    formConfig.functions.push({
      identifier: 'sumTaxLot',
      fn: this.sumTaxLot
    });
    formConfig.functions.push({
      identifier: 'isRelatedProject',
      fn: this.isRelatedProject
    });
    formConfig.functions.push({
      identifier: 'isEditableLot',
      fn: this.isEditableLot
    });
    formConfig.functions.push({
      identifier: 'addCofinancedLine',
      fn: this.addCofinancedLine.bind(this)
    });

    formConfig.functions.push({
      identifier: 'addBudgetAccountLine',
      fn: this.addBudgetAccountLine.bind(this)
    })

    formConfig.functions.push({
      identifier: 'changeCoef',
      fn: this.changeCoef.bind(this)
    });


    return of(formConfig);
  }

  initHeaderActions() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.EDIT_ADJUDICACION));
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (this.appConfig.getValue('requested.material.management')) {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'ProcurementProject.requestedMaterial.title',
          'fas fa-pencil-alt',
          'btn-primary',
          true,
          this.windowHash
        ),
        () => {

          this.openMaterialEditor(this.award)

        });
    }


    if ('AYMAD' === this.cliente
      && this?.task
      && getSimpleIdentifierFromString(this.project?.classification?.complementarySystem?.identifier) === 'AM'
      && (!this.project?.budget?.['withoutUnitPrice'])
    ) {


      this.subscribe(this.headerActionsService
        .addWindowAction(
          'Precios unitarios',
          undefined,
          'btn-primary',
          true,
          this.windowHash

        ),
        () => {

          this.openUnitPricesEditor(this.award)

        });


    }
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.save',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.updateAward(this.award, true);
      });
  }



  private createFormConfig(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'awardInterfaceSettings.json',
      this.award
    ));
  }
  ngAfterContentInit(): void {

  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);

        this.dialogConfig = null;
        this.ref = null;
        super.ngOnDestroy();
      })));
  }

  public isLoaded(): boolean {
    return this.loaded; // this.award !== undefined && this.formConfig !== undefined;
  }

  close() {
    this.ref.close(this.award);
    // this.ref.close();
  }

  addNewLot() { }

  loadAward(identifier: string): Observable<any> {
    return this.plycaService.getDossierAward(identifier);
  }

  getTenderLotById(tender: TenderDTO, lotNumber: any) {
    let _lot = tender.tendersLots.find(
      tenderLot =>
        '' + lotNumber === getSimpleIdentifierFromString(tenderLot.identifier)
    );
    return _lot;
  }

  getProjectLotById(tLot: TenderLot): ProcurementProjectLotDTO {
    return this.project.breakdownLot.lots.find(
      lot =>
        '' + lot.lotNumber ===
        tLot.identifier.substring(0, tLot.identifier.indexOf('<>'))
    );
  }

  private lot2TenderLot(lot: ProcurementProjectLotDTO) {
    let awardLot: AwardLotDTO = new AwardLotDTO();
    awardLot.projectLot = lot;
    awardLot.amountwithoutTax = 10;
    return awardLot;
  }

  updateAward(award: AwardDTO, loaded: any) {
    this.waitService.startWaiting();
    console.log('INICIO UPDATEAWARD');
    award['dossierID'] = this.project.identifier;
    let tmpAward: any;
    tmpAward = lodash.cloneDeep(this.award);
    console.log('antes de limpiar', this.award, tmpAward);
    // limpiar variables de apoyo de tablas
    tmpAward = JSON.parse(
      JSON.stringify(tmpAward, (k, v) => (k === '_parent' ? undefined : v))
    );

    console.log('después de limpiar', this.award, tmpAward);

    tmpAward.adjudicationCoefficient = this.roundDecimals(tmpAward.adjudicationCoefficient, 8);

    let validationContext = 'awards/validations/Update';
    this.error = false;
    this.subscribe(this.plycaService
      .validate(this.configuration.AWARD_SERVICE_URL, 'Update', tmpAward),
      (validation: ValidationResultDTO) => {
        if (validation.result === ResultTypeDTO.ERROR) {
          this.frmAward.manageFormException(validation);
          this.error = true;
        } else if (validation.result === ResultTypeDTO.WARNING) {
          this.frmAward.manageFormException(validation);
          this.warning = true;
          this.error = false;
        }
        if (!loaded) {
          this.waitService.cancelWaiting();
        } else {
          this.update(tmpAward, loaded);
        }
      },
      error => {
        console.log('UPDATE AWARD ERROR', error);
        if (!loaded) {
          this.waitService.cancelWaiting();
        }
        this.waitService.cancelWaiting();
        this.frmAward.manageFormException(error);
      }
    );
  }

  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  private update(tmpAward: AwardDTO, loaded: any) {
    this.subscribe(this.plycaService
      .update<AwardDTO>(this.configuration.AWARD_SERVICE_URL, tmpAward),
      (updatedAward: AwardDTO) => {
        console.log('AWARD ACTUALIZADO', updatedAward);
        if (this.error) {
          this.waitService.cancelWaiting();
          this.confirmationService.confirm({
            message:
              'Se han detectado errores que impiden tramitar la propuesta de adjudicación. ¿Desea continuar y grabar la ficha?',
            accept: () => {
              // Graba la tarea.
              this.ref.close(updatedAward);
            },
            reject: () => {
              this.waitService.cancelWaiting();
              console.log('NO HACE NADA FPUB');
            }
          });
        } else if (this.warning) {
          this.confirmationService.confirm({
            message:
              'Se han detectado advertencias que no impiden tramitar. ¿Desea continuar?',
            accept: () => {
              // Graba la tarea.
              this.ref.close(updatedAward);
            },
            reject: () => {
              this.waitService.cancelWaiting();
              console.log('NO HACE NADA FPUB');
            }
          });
        } else {
          if (loaded) {
            this.ref.close(updatedAward);
          }
        }
      },
      error => {
        console.log('UPDATE AWARD ERROR', error);
        this.frmAward.manageFormException(error);
        this.waitService.cancelWaiting();
        this.warning = false;
        this.error = false;
      }
    );
  }

  cancel() {
    this.ref.close();
  }

  validate() {
    console.log('validando');
    let validationContext = 'awards/validations/Insert';
    if (this.award.identifier) {
      validationContext = 'awards/validations/Update';
    }
    console.log('VALIDANDO MODELO', this.award);
    let tmpAward: any;
    tmpAward = lodash.cloneDeep(this.award);
    tmpAward = JSON.parse(
      JSON.stringify(tmpAward, (k, v) => (k === '_parent' ? undefined : v))
    );
    this.frmAward.validate(validationContext, tmpAward);
  }

  public sumAmountLot(model: any) {
    let amountSum = 0;

    model.awardsLots.forEach((awardLot: AwardLotDTO) => {
      amountSum += amountSum + awardLot.amountwithoutTax;
    });
    return amountSum;
  }

  public sumTaxLot(model: any) {
    let amountSumTax = 0;

    model.awardsLots.forEach((awardLot: AwardLotDTO) => {
      amountSumTax += amountSumTax + awardLot.amountTax;
    });
    return amountSumTax;
  }

  public isRelatedProject(model: any) {
    if (model._parent && model._parent.relatedProject !== undefined) {
      return model._parent.relatedProject;
    } else {
      return model.relatedProject;
    }
  }

  public changeCoef(model: any) {
    if (model.readjustedPrice !== undefined && !model.readjustedPrice) {
      this.confirmationService.confirm({
        message: this.translateService.instant('AwardInfo.msjCof'),
        accept: () => {
          //Si se selecciona no se deben recargar los importes de la oferta

          if (model.tender.tenderLots !== undefined && model.tender.tenderLots.length > 0) {
            model.tender.tenderLots.forEach((tenderLot: TenderLotV2DTO) => {
              model.awardsLots.forEach((awardLot: AwardLotDTO) => {
                if (awardLot.projectLot.lotId === tenderLot.procurementProjectLot.lotId) {
                  awardLot.amount = tenderLot.economicOffer.totalAmount;
                  awardLot.amountwithoutTax = tenderLot.economicOffer.taxExclusiveAmount;
                  awardLot.amountTax = tenderLot.economicOffer.taxAmount;
                }
              });
            });
          }
        }
      });

    }

  }

  public isEditableLot(model: any) {
    let resultado = true;
    //LOTES_DEL_EXP_EDITABLE: Indica si está editable la tabla de lotes en la adjudicación.
    if (model != null
      && model.context != null
      && model.context.configurations !== undefined
      && model.context.configurations.editableLot !== undefined
      && !model.context.configurations.editableLot.value) {
      resultado = false;
    }
    /*else {
      //Si está visible la información de reajuste y se está adjudicando por oferta
      if (model != null
        && model.context != null
        && model.context.configurations !== undefined
        && model.context.configurations.reajustedPriceVisible !== undefined
        && model.context.configurations.reajustedPriceVisible.value && model.tender) {
        //Si está seleccionado el check de reajuste o el expediente está en el atributo FADJ_ACTIVAR_IMPORTES
        //Lo importes deben estar habilitados.
        if (model.readjustedPrice !== undefined && model.readjustedPrice || this.resultActivarImporte) {
          resultado = true;
        } else {
          resultado = false;
        }
      }
    }*/
    return resultado;
  }


  openMaterialEditor(award?: AwardDTO) {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TenderInfo.actions.editMaterial'),
      width: '95%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['award'] = award;
    context['showLotes'] = this.project?.breakdownLot?.apportioned === true;
    config['context'] = context;
    config.data = {
      task: this.task
    };



    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(AwardRequestedMaterialListComponent, config).onClose,
      (materialSaved: boolean) => {

        // this.reloadAndValidate(tenderSaved);
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }


  openUnitPricesEditor(award?: AwardDTO) {
    let config: DynamicDialogConfig = {
      header: 'Edición de precios unitarios',
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    // context['readonly'] = this.readOnly;
    context['award'] = award;
    config['context'] = context;
    config.data = {
      task: this.task
    };


    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(UnitPricesListComponent, config).onClose,
      (materialSaved: boolean) => {

      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }

  addCofinancedLine(model: any) {
    let config: DynamicDialogConfig = {
      header: 'Buscador cofinancación',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PROPUESTAID';


    /*if (this.project.projectRelations !== undefined) {
      let relationProject = new ProjectRelationDTO();
      relationProject = this.project.projectRelations[4];
      if (relationProject) {
        param1.value = relationProject.relationsAsSecundary[0].identifier;
      }
    }*/
    param1.value = this.project.identifier;

    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'DIVISION';
    //La división de la propuesta de gasto
    param2.value = '0';

    parametersURL.push(param2);

    let autoSearch = true;
    config['context'] = new SearchSettingDTOModal('COFINANCIEDLINE_PROJECT_SEARCH', autoSearch, parametersURL);

    let newRow: CofinancingLineDTO = new CofinancingLineDTO();

    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: SearchSelectionResultDTO) => {
          if (result) {
            newRow.budgetYear = result.content.ANOPARTIDA.value;
            if (result.content.PARTIDA) {
              newRow.budgetItem = result.content.PARTIDA.value;
            }
            //newRow.exercise = result.content.EJERCICIO.value;
            newRow.entity = result.content.ENTIDAD.value;
            newRow.entityDescription = result.content.DES_ENTIDAD.value;
            newRow.project = result.content.PROYECTO.value;
            //newRow.budgetAmount = result.content.IMPORPARTIDA.value;

            return newRow;

          } else {
            console.log('Cerrado sin seleccionar');
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );




    return newRow;
    //return new BudgetAccountLineDTO();
  }

  addBudgetAccountLine(model: any) {
    let config: DynamicDialogConfig = {
      header: 'Buscador partidas',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PROPUESTAID';


    /*if (this.project.projectRelations !== undefined) {
      let relationProject = new ProjectRelationDTO();
      relationProject = this.project.projectRelations[4];
      if (relationProject) {
        param1.value = relationProject.relationsAsSecundary[0].identifier;
      }
    }*/
    param1.value = this.project.identifier;

    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'LOTEID';
    //La división de la propuesta de gasto
    param2.value = '0';

    parametersURL.push(param2);

    let autoSearch = true;
    config['context'] = new SearchSettingDTOModal('BUDGETACCOUNTLINE_PROJECT_SEARCH', autoSearch, parametersURL);

    let newRow: BudgetAccountLineDTO = new BudgetAccountLineDTO();

    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: SearchSelectionResultDTO) => {
          if (result) {
            newRow.year = result.content.PRESUPANO.value;
            newRow.organic = result.content.ANUORGANICA.value;
            newRow.functional = result.content.PRESUPANO.value;
            newRow.economical = result.content.ANUECONOMICA.value;
            newRow.investnmentProject = result.content.PROYINVID.value;
            newRow.exercise = result.content.EJERCICIO.value;

            return newRow;

          } else {
            console.log('Cerrado sin seleccionar');
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );




    return newRow;
    //return new BudgetAccountLineDTO();
  }
}
